(function () {
    'use strict';

    angular
        .module('homeMyTasksControllers', ['services.authenticatedUser',
                                           'actionPlanModule',
                                           'aricModule',
                                           'businessPlanningModule',
                                           'governanceProcessModule',
                                           'recommendationModule',
                                           'riskModule',
                                           'recomModule']);
})();
